import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Container,
} from "@mui/material";
import { Link } from "react-router-dom";
import guardImage from "../assets/guardremote.jpg";
import guardImage2 from "../assets/guardsee.jpg";
import guardImage3 from "../assets/nameplateguard.jpg";
import guardImage4 from "../assets/midcompsee.jpg";
import guardImage5 from "../assets/backcompsee.jpg";
import guardImage6 from "../assets/compseeguard.jpg";
import guardImage7 from "../assets/girltorch.jpg";
import guardImage8 from "../assets/guardnameplate.jpg";
import guardImage9 from "../assets/securitycheck.jpg";
import guardImage10 from "../assets/walkitalki.jpg";

const googleFormLink = "https://forms.gle/juQW6MV4AeVaBEMA9";

function Home() {
  const services = [
    { title: "Security Guards", img: guardImage9 },
    { title: "Mobile Patrol", img: guardImage10 },
    { title: "Home Watch", img: guardImage7 },
    { title: "Special Event Security", img: guardImage6 },
    { title: "Concierge & Guest Services", img: guardImage5 },
    { title: "First Aid", img: guardImage8 },
  ];
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          backgroundImage: `url(${guardImage3})`,
          backgroundSize: "cover",
          // backgroundPosition: "center",
          height: { xs: "60vh", md: "70vh" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
          boxShadow: "inset 0 0 0 1000px rgba(0,0,0,0.5)",
          objectFit: "cover",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: { xs: "28px", sm: "36px", md: "48px" },
              fontWeight: "bold",
              mb: 2,
            }}
          >
            Redefining Security Standards
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "18px", md: "20px" },
              mb: 3,
            }}
          >
            Smart Protection. Strong People. Real Safety.
          </Typography>

          <Button
            variant="contained"
            size="large"
            sx={{ bgcolor: "#ffcc00", color: "black", fontWeight: "bold" }}
            href={googleFormLink}
            target="_blank"
          >
            Get In Touch
          </Button>
        </Box>
      </Box>

      {/* Feature Cards (below hero) */}
      <Container sx={{ py: 8 }}>
        <Grid container spacing={4} justifyContent="center" >
          {[
            {
              title: "Complete Security Services",
              desc: "Dependable protection you can trust.",
              img: guardImage2,
            },
            {
              title: "Expert Security Training",
              desc: "Building the next generation of security professionals.",
              img: guardImage3,
            },
          ].map((item, i) => (
            <Grid item xs={12} md={6} key={i}>
              <Card sx={{ height: "100%" }}>
                <CardMedia component="img" height="250" image={item.img} sx={{ objectFit: "cover" }} />
                <CardContent sx={{ textAlign: "center" ,width:'100%'}}>
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2">{item.desc}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Services Section */}
      <Box sx={{ p: 5, textAlign: "center", bgcolor: "#f5f5f5" }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: "bold" }}>
          Our Services
        </Typography>
        <Grid container spacing={4} justifyContent="center" sx={{width:'100%'}}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index} sx={{ width: "100%" }}>
              <Card sx={{ height: "100%" }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={service.img}
                  alt={service.title}
                  sx={{ objectFit: "cover" }}
                />
                <CardContent>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {service.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Call To Action - Two Cards */}
      <Box
        sx={{
          backgroundColor: "black",
          color: "white",
          textAlign: "center",
          p: 5,
        }}
      >
        <Typography variant="h4" sx={{ mb: 5 }}>
          Start Your Security Career
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {/* Request a Quote Card */}
          <Grid item xs={12} sm={6}>
            <Card
              sx={{
                cursor: "pointer",
                textAlign: "center",
                "&:hover": { transform: "scale(1.05)", transition: "0.3s" },
              }}
              onClick={() => {
                const contactSection = document.getElementById("quote");
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <CardMedia component="img" height="200" image={guardImage4} sx={{ objectFit: "cover" }} />
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "#002147" }}
                >
                  Request a Quote
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Apply Now Card */}
          <Grid item xs={12} sm={6}>
            <Card
              sx={{
                cursor: "pointer",
                textAlign: "center",
                "&:hover": { transform: "scale(1.05)", transition: "0.3s" },
              }}
              onClick={() => {
                const contactSection = document.getElementById("apply");
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <CardMedia component="img" height="200" image={guardImage5} sx={{ objectFit: "cover" }} />
              <CardContent>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "#002147" }}
                >
                  Apply Now
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Family Owned Section */}
      <Box sx={{ p: 5, textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: "bold" }}>
          Trusted Security Solutions | Since 2025
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          LineGuard Security is a professionally managed security services
          company dedicated to protecting people, property, and businesses.
          Founded in 2025, our mission is to deliver reliable, disciplined, and
          technology-driven security solutions tailored to modern risks.
        </Typography>
      </Box>

      {/* Community Section */}
      <Container sx={{ py: 8 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6} sx={{ width: "100%" }}>
            <CardMedia
              component="img"
              height="300"
              width="100%"
              image={guardImage}
              sx={{ objectFit: "cover" }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant="h4"
              sx={{ mb: 3, fontWeight: "bold", color: "#002147" }}
            >
              Security You Can Depend On
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              We specialize in providing trained security personnel, site
              protection, and job opportunities for skilled individuals who want
              to build a career in the security industry. Our approach combines
              human vigilance, clear protocols, and ethical service standards to
              ensure safety you can trust.
            </Typography>
            <Button
              variant="outlined"
              size="large"
              sx={{
                color: "#002147",
                borderColor: "#002147",
                fontWeight: "bold",
              }}
              component={Link}
              to="/about"
            >
              Learn More
            </Button>
          </Grid>
        </Grid>
      </Container>

      {/* Testimonials */}
      <Box
        sx={{ bgcolor: "black", color: "white", py: 8, textAlign: "center" }}
      >
        <Container>
          <Typography variant="h4" sx={{ mb: 3, fontWeight: "bold" }}>
            What Our Clients Say
          </Typography>
          <Typography
            variant="body1"
            sx={{ maxWidth: "700px", mx: "auto", fontStyle: "italic" }}
          >
            “Lineguard Security has been an invaluable partner in keeping our
            business safe. Their professionalism and dedication are unmatched.”
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}

export default Home;
